import React from "react";
import { Parallax } from "react-scroll-parallax";
import "./parallax.scss";

const ParallaxBackground: React.FC = () => {
  return (
    <div className="parallax-bg">
      {/* <Parallax speed={-20}>
        <div className="parallax-icon parallax-icon--1">🛡️</div>
      </Parallax>
      <Parallax speed={-10}>
        <div className="parallax-icon parallax-icon--2">🔒</div>
      </Parallax>
      <Parallax speed={-30}>
        <div className="parallax-icon parallax-icon--3">🐞</div>
      </Parallax>
      <Parallax speed={-15}>
        <div className="parallax-icon parallax-icon--4">💻</div>
      </Parallax> */}
    </div>
  );
};

export default ParallaxBackground;
